import type { FormatXMLElementFn } from 'intl-messageformat';
import type { PrimitiveType } from 'react-intl';
import { FormattedMessage } from 'react-intl';

type MessageValues = Record<
  string,
  PrimitiveType | React.ReactElement | FormatXMLElementFn<React.ReactNode>
>;

export const translate = (id: string, values?: MessageValues): JSX.Element => (
  <FormattedMessage id={id} values={values} />
);
